<template>
  <div>
    <cancel-info
      ref="cancelInfo"
      :aro_no="aro_no"
      :paymentCase = "paymentCase"
      v-show="cancelInfoShow"
      @cancel="onClickCancel"
      @doWithdraw="onClickWithdraw"
      @nextProcess="onClickNextProcess"
    />

    <cancel-card
      ref="cancelCard"
      :aro_no="aro_no"
      :memberId="getMemberId()"
      v-show="cancelCardShow"
      @cancel="onClickCancel"
      @doWithdraw="onClickWithdraw"
    />

    <cancel-account
      ref="cancelAccount"
      :aro_no="aro_no"
      v-show="cancelAccountShow"
      @cancel="onClickCancel"
      @doWithdraw="onClickWithdraw"
    />

  </div>
</template>
<script>
import AroBase from '@/components/base/AroBase';
import CancelInfo from './cancelInfo';
import CancelCard from './cancelCard';
import CancelAccount from './cancelAccount';
import * as ErrMsg from "@/utils/error_msg";
import * as Crypto from '@/utils/cryptoUtil';

export default {
  name: "AroCancel",
  extends: AroBase,
  components: {
    CancelInfo,
    CancelCard,
    CancelAccount
  },
  props:{
    aro_no: {
      type: String,
      required: true
    },
    paymentCase:{
      type: String,
      required: true
    }
  },
  data() {
    return {
      //View Data
      viewData : {
        pd_list : []
      },
      params : {},

      //popup
      //
      cancelInfoShow : true,
      cancelInfoData : {},

      cancelCardShow : false,
      cancelCardData : {},

      cancelAccountShow : false,
      cancelAccountData : {},

      paymentCase : "",

      testText : ""
    };
  },
  created() {
  },
  mounted() {
    let _this = this;

    _this.loadData();
  },
  methods: {
    /**
     * JQuery UI
     */
    initUI(){

    },

    /**
     * API Request
     */
    //나의 정기구매 정보 가져오기
    apiGetAroDetail(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_aro_detail`, {
        params: {
          aro_no : _this.aro_no
        }
      });
    },

    apiCancelAro(paramData){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/cancel_aro`, {
        params: {
          aro_no : _this.aro_no,
          member_name : _this.getMemberNmKr(),
          ...paramData
        }
      });
    },

    //ARO 변경 가능 여부 체크
    apiCheckAroModifyStatus : function(aro_no){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/modify_status`, {
        params: {
          adpNo : aro_no
        }
      });
    },

    /**
     * Local function
     */
    //데이터 로드
    loadData(){
      let _this = this;

      //show loading
      _this.$showLoading();
      _this.apiGetAroDetail().then(res=>{

        if (res.status === 200 && res.data.status === "0000") {

          _this.viewData = {
            ...res.data
          };

          //ARO 철회 정보 표시
          _this.cancelInfoData = {..._this.viewData};
          _this.$refs.cancelInfo.initData(_this.cancelInfoData);
          _this.cancelInfoShow = true;

           return _this.apiAutoPaymentDate();

        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

      }).then(res=>{

          if (res.status === 200 && res.data.status === "0000") {
            if(res.data.result){
              _this.paymentCase = res.data.case
            }else{
              _this.paymentCase = "1";
            }
            return;
          }else{
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg).then(res => {});
          }
      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
         _this.$hideLoading();
      });
    },

    //철회 취소
    onClickCancel(){
      let _this = this;
      _this.$router.go(-1);
    },

    //철회 하기
    onClickWithdraw(payment_typ, additionalData){
      let _this = this;

      const options = {cancelLabel: '취소', okLabel:'철회'};

      let msg = `정기구매 [${_this.aro_no}] 주문을 철회하시겠습니까?`;
      if(_this.viewData.cancel_amt >= 0){
          msg = `정기구매(${_this.aro_no}) 철회로 인한 추가 결제금액은
          ${_this.$fmt.WON(_this.$nvl(_this.viewData.cancel_amt,0))} 원입니다.<br/>
          해당 금액은 기존 진행하던 카드 또는 계좌로 결제됩니다.철회 하시겠습니까?`
      }

      _this.$dialogs.confirm(msg, options).then(res=>{
        if(res.ok){
          _this.withdrawProcess(payment_typ, additionalData);
        }
      });
    },

    //다음 진행
    onClickNextProcess(){
      let _this = this;

      if(_this.AroConst.VALUE_payment_type_credit_card == _this.viewData.payment_typ){
        //신용카드
        _this.cancelInfoShow = false;

        _this.cancelCardData = {..._this.viewData};
        _this.$refs.cancelCard.initData(_this.cancelCardData);
        _this.cancelCardShow = true;
        window.scrollTo(0, 0);

      }else if(_this.AroConst.VALUE_payment_type_account_transfer == _this.viewData.payment_typ){
        //계좌이체
        _this.cancelInfoShow = false;

        _this.cancelAccountData = {..._this.viewData};
        _this.$refs.cancelAccount.initData(_this.cancelAccountData);
        _this.cancelAccountShow = true;
        window.scrollTo(0, 0);
      }
    },

    //철회
    withdrawProcess(payment_typ, additionalData){
      let _this = this;

      let paramData = {};
      if(_this.AroConst.VALUE_payment_type_credit_card == payment_typ){
        //신용카드
        paramData = {
          ccard_no : Crypto.replaceStringForCardNumber(_this.viewData.ccard_no, _this.viewData, _this.getMemberId()),
          ccard_exp : Crypto.replaceStringForTextIntegration(_this.viewData.ccard_exp, _this.viewData, _this.getMemberId()),
          integration: _this.viewData.integration
        };

        paramData = _this.processEncodeOrNot(paramData, _this.viewData);

      }else if(_this.AroConst.VALUE_payment_type_account_transfer == payment_typ){
        //계좌이체
        paramData = {
          birth_dt : additionalData.birth,
          cms_no : _this.viewData.cms_no,
          bank_account : _this.viewData.bank_account,
          bank_no : _this.viewData.bank_code
        };
      }else{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {});
        return;
      }

      //show loading
      _this.$showLoading();
      _this.apiCheckAroModifyStatus(_this.aro_no).then((res)=>{
        if (res.status === 200 && res.data.status === "0000") {
            return _this.apiCancelAro(paramData);
          }else{
            //ARO 변경 불가능한 경우
            //console.error(res);
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
            .then(res => {});
            return null;
        }
      }).then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          let message = "";
          if(_this.AroConst.VALUE_payment_type_credit_card == payment_typ){
            message = "철회처리가 완료 되었습니다.";
          }else if(_this.AroConst.VALUE_payment_type_account_transfer == payment_typ){
            message = "철회처리가 접수 되었습니다.";
          }

           _this.$dialogs.alert(message).then(res => {
             _this.$router.push(`${_this.$aroBasePath}/aroList`);
           });


        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
         _this.$hideLoading();
      });
    },

    apiAutoPaymentDate(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/autoPaymentDate`, {
        params: {}
      });
    },
    processEncodeOrNot(paramData, viewData) {
      let _this = this;

      let keys = Object.keys(paramData);
      for(let i=0; i<keys.length; i++) {

        let jsonKey = keys[i];
        let value = '';

          if (jsonKey === 'ccard_no') {
            /* 암호화 여부를 카드번호 length 와  integration 복호화 키 여부로 체크  */
            if (paramData.ccard_no.length > 16 && !viewData.integration) {
              value = GibberishAES.aesDecrypt(paramData.ccard_no, _this.getMemberId() + viewData.integration);
            } else {
              value = paramData.ccard_no;
            }
            paramData[jsonKey] = GibberishAES.aesEncrypt(value, _this.$getMemberIdKey());
          }

          if (jsonKey === 'ccard_exp') {
            if (paramData.ccard_exp.length > 6 && !viewData.integration) {
              value = GibberishAES.aesDecrypt(paramData.ccard_exp, _this.getMemberId() + viewData.integration)
            } else {
              value = paramData.ccard_exp;
            }
            paramData[jsonKey] = GibberishAES.aesEncrypt(value, _this.$getMemberIdKey());
          }
      }
      return paramData;
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/my/aro/cancel.vue